import React from 'react';
import { FilePlus2, CalendarClock, BadgeCheck, XOctagon, Percent, TrendingUp } from 'lucide-react';
import { ApplicationMetrics } from '../../types';

interface Props {
  metrics: ApplicationMetrics;
  filtered: boolean;
}

const MetricCard: React.FC<{ icon: React.ReactNode; label: string; value: string | number; highlight?: boolean }> = ({
  icon,
  label,
  value,
  highlight,
}) => (
  <div className={`bg-white border rounded-card p-4 ${highlight ? 'border-brand-200 shadow-soft' : 'border-zinc-200'}`}>
    <div className="flex items-center gap-2 text-[11px] text-zinc-500 mb-2">
      <span className={highlight ? 'text-brand-600' : 'text-zinc-400'}>{icon}</span>
      {label}
    </div>
    <p className="font-display text-2xl font-semibold text-foreground tabular-nums">{value}</p>
  </div>
);

const MetricsBar: React.FC<Props> = ({ metrics, filtered }) => {
  const responseRate = Math.round(metrics.responseRate * 100);
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
      <MetricCard
        icon={<FilePlus2 className="w-3.5 h-3.5" />}
        label="Total applications"
        value={metrics.totalApplications}
        highlight
      />
      <MetricCard
        icon={<CalendarClock className="w-3.5 h-3.5" />}
        label="Upcoming interviews"
        value={metrics.upcomingInterviews}
      />
      <MetricCard
        icon={<BadgeCheck className="w-3.5 h-3.5" />}
        label="Offers"
        value={metrics.offers}
      />
      <MetricCard
        icon={<XOctagon className="w-3.5 h-3.5" />}
        label="Rejections"
        value={metrics.rejections}
      />
      <MetricCard
        icon={<Percent className="w-3.5 h-3.5" />}
        label="Response rate"
        value={`${responseRate}%`}
      />
      {filtered && (
        <div className="col-span-full flex items-center gap-1.5 text-xs text-brand-700 bg-brand-50 border border-brand-100 rounded-card px-3 py-2">
          <TrendingUp className="w-3.5 h-3.5" />
          Metrics reflect the filtered results.
        </div>
      )}
    </div>
  );
};

export default MetricsBar;